import moment from 'moment';
import DTO from './DTO';

class MetaDTO extends DTO {
  constructor(params, isValidInit) {
    const normalizedParams = params && params.total == null && params.total_count != null
      ? { ...params, total: params.total_count }
      : params;
    const attributes = [
      {
        name: 'limit',
        type: String,
      },
      {
        name: 'page',
        type: String,
      },
      {
        name: 'server_time',
        type: moment,
        couldBeNull: true,
      },
      {
        name: 'total',
        type: String,
      },
    ];
    super(attributes, normalizedParams, isValidInit);
  }
}

export default MetaDTO;
